import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'heading-[24px] lg:heading-[40px] mb-2 font-semibold lg:mb-6',
    text: 'heading-s lg:heading-m mb-10',
    subtitle: 'heading-xl mb-4',
    form: 'flex flex-col gap-9.5',
    block: 'w-full',
    inputs: 'flex flex-col gap-5.5',
    inputWrapper: 'relative',
    input: 'heading-m',
    inputSearch: 'px-4',
    disclaimer: 'heading-xs text-[#595959]',
    link: 'underline underline-offset-3',
    button: 'mb-5 w-full gap-1.5',
    addButton: 'heading-s-intr-bold m-0 mt-2 w-fit p-0 tracking-[0.06em]',
    addButtonContent: 'flex items-center gap-1.5',
    error: 'text-error px-4 pt-1 text-sm font-light',

    success: 'pt-15',
    buttonSuccess: 'mt-2 inline-block w-full',
    br: 'hidden lg:block'
  }
});
